import styled from 'styled-components'

export const SobreWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 60px;
  margin-top: 60px;
  width: 100%;

  & h1 {
    font-size: 3rem;
    font-weight: 700;
    text-align: left;
    margin-bottom: 30px;
    color: #4c4c4c;
    margin-top: 30px;
  }

  & h2 {
    font-size: 1.7rem;
    margin-bottom: 40px;
    color: #4c4c4c;
    font-weight: 700;
  }

  & .text {
    font-size: 20px;
    color: #4c4c4c;
    font-weight: 500;
    margin-bottom: 0px;
  }

  & .link {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .label-link {
    font-size: 1.25rem;
    color: #191919;
    font-weight: 700;
    text-align: center;
  }
  @media screen and (max-width: 991px) {
    & h1 {
      font-size: 3rem;
    }

    & h2 {
      font-size: 1.25rem;
    }

    & .text {
      font-size: 1rem;
    }

    & .label-link {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 768px) {
    & h1 {
      font-size: 2.5rem;
    }

    & h2 {
      font-size: 1rem;
    }

    & .text {
      font-size: 0.9rem;
    }

    & .label-link {
      font-size: 0.9rem;
    }
  }
`

export const MissaoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #ededed;
  width: 100%;
  padding: 80px 40px;

  & h2 {
    color: #4c4c4c;
    font-size: 3rem;
    font-weight: 700;
    margin-bottom: 30px;
  }

  & h3 {
    color: #4c4c4c;
    font-size: 1.7rem;
    font-weight: 800;
    margin-bottom: 20px;
  }

  /* & h4 {
    color: #4c4c4c;
    font-size: 20px;
    font-weight: 600;
    flex-wrap: nowrap;
  } */

  p {
    font-weight: 500;
    font-size: 20px;
    flex-wrap: nowrap;
  }

  @media screen and (max-width: 991px) {
    & h2 {
      font-size: 3rem;
    }

    & h3 {
      font-size: 1.1rem;
    }

    & h4 {
      font-size: 0.9rem;
    }

    p {
      font-size: 0.9rem;
    }
  }

  @media screen and (max-width: 768px) {
    & h2 {
      font-size: 2.5rem;
    }

    & h3 {
      font-size: 1rem;
    }

    & h4 {
      font-size: 0.8rem;
    }

    p {
      font-size: 0.8rem;
    }
  }
`

export const PapelSocialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 80px 40px;

  & h2 {
    color: #4c4c4c;
    font-size: 3rem;
    font-weight: 700;
    margin-bottom: 10px;
    text-align: start;
  }

  & h3 {
    color: #4c4c4c;
    font-size: 1.7rem;
    font-weight: 700;
    margin-bottom: 30px;
  }

  & .card-projeto {
    padding: 20px;
    background: rgb(241 241 241);
    color: #462b6e;
    border-radius: 15px;
    display: flex;
    gap: 20px;
    min-height: 350px;

    & .card-projeto-img {
      object-fit: contain;
      height: auto;
    }

    & .title {
      font-size: 1.75rem;
      font-weight: 700;
    }

    & .social {
      font-size: 1.125rem;
      margin-top: -20px;
      margin-bottom: 20px;
    }

    & .subtitle {
      font-size: 1.125rem;
      font-weight: 700;
      margin-bottom: 20px !important;
    }

    & p {
      font-size: 1rem;
      font-weight: 500;
      margin-top: 20px;
    }

    & .card-projeto-img {
      width: 200px;
    }
  }

  @media screen and (max-width: 991px) {
    & h2 {
      font-size: 3rem;
    }

    & h3 {
      font-size: 1.1rem;
    }

    & .card-projeto {
      gap: 15px;
      min-height: 250px;
      flex-direction: column;

      & .title {
        font-size: 1.5rem;
      }

      & .social,
      & .subtitle {
        font-size: 1rem;
      }

      & p {
        font-size: 0.9rem;
      }

      & .card-projeto-img {
        width: 150px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    & h2 {
      font-size: 2.5rem;
    }

    & h3 {
      font-size: 1rem;
    }

    & .card-projeto {
      gap: 10px;
      min-height: 200px;

      & .title {
        font-size: 1.25rem;
      }

      & .social,
      & .subtitle {
        font-size: 0.9rem;
      }

      & p {
        font-size: 0.8rem;
      }

      & .card-projeto-img {
        width: 100px;
      }
    }
  }
`
